import { observer } from "mobx-react";
import FontHeading4 from "../../../../../components/fonts/font-heading4/font-heading4";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../components/fonts/font-props";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import OnBoardingScreenTitle from "../../onboarding-screen-title/onboarding-screen-title";
import EnableReturnGuardOnboardingStep from "../enable-return-guard-onboarding-step/enable-return-guard-onboarding-step";
import enableStep1 from "../../../../../images/onboarding/enable-step-1.svg";
import enableStep2 from "../../../../../images/onboarding/enable-step-2.svg";
import enableStep3 from "../../../../../images/onboarding/enable-step-3.svg";
import enableStep4 from "../../../../../images/onboarding/enable-step-4.svg";
import enableReturnGuard from "../../../../../images/onboarding/enable-return-guard.gif";
import './enable-return-guard-shopify-extension.scss';

interface IEnableReturnGuardShopifyExtension {
    shopifyExtensionUrl?: string;
}

export interface IEnableReturnGuardStep {
    imgsrc: string;
    text: string;
    shopifyExtensionUrl?: string;
}

const EnableReturnGuardShopifyExtension: React.FC<IEnableReturnGuardShopifyExtension> = observer(({ shopifyExtensionUrl }) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-onboarding";

    const steps: IEnableReturnGuardStep[] = [
        {
            imgsrc: enableStep1,
            text: getTranslation('ENABLE_STEP_1', scope),
            shopifyExtensionUrl: shopifyExtensionUrl,
        },
        {
            imgsrc: enableStep2,
            text: getTranslation('ENABLE_STEP_2', scope),
        },
        {
            imgsrc: enableStep3,
            text: getTranslation('ENABLE_STEP_3', scope),
        },
        {
            imgsrc: enableStep4,
            text: getTranslation('ENABLE_STEP_4', scope),
        },
    ]
    
    return (
        <div className="enable-return-guard-screen">
            <div className="enable-return-guard-screen-title-wrapper">
                <OnBoardingScreenTitle
                    titleText={getTranslation('ENABLE_RETURN_GUARD_TITLE', scope)}
                    descriptionText={`${getTranslation('ENABLE_RETURN_GUARD_DESCRIPTION_1', scope)}\n${getTranslation('ENABLE_RETURN_GUARD_DESCRIPTION_2', scope)}`}
                    maxWidth={565}
                />
            </div>
            <div className="enable-return-guard-screen-content">
                <div className="enable-return-guard-screen-text">
                    <FontHeading4 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation('ENABLE_STEPS_TITLES', scope)}</FontHeading4>
                    <div className="enable-return-guard-screen-steps">
                        {steps.map((step, index) => <EnableReturnGuardOnboardingStep step={step} key={index} />)}
                    </div>
                </div>
                <img src={enableReturnGuard} alt="enable return guard" />
            </div>
        </div>
    );
});

export default EnableReturnGuardShopifyExtension;